import { render, staticRenderFns } from "./OrganizationEditView.vue?vue&type=template&id=c7221f48&"
import script from "./OrganizationEditView.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports